import {
  FeaturesHighClass,
  FeaturesRankDiamond,
  FeaturesRankPlatinum,
  FeaturesTopClass,
} from '@travel/icons/features';
import cx from '@travel/ui/utils/classnames';

import { GradeHotelType, GradeMemberRank } from 'favoriteList/constants/favoriteLists';
import FurusatoTaxLabel from './FurusatoTaxLabel';
import HotelMembershipExchangeLabel from './HotelMembershipExchangeLabel';
import HotSpringLabel from './HotSpringLabel';
import SustainabilityLabel from './SustainabilityLabel';

import type { Tags } from 'Provider-Types';

import styles from './featureLabel.module.scss';

// TODO: confirm the type of tags, if we don't need to use the type, we can refactor the code
type Props = {
  tags: Tags;
  className?: string;
};

const FeatureLabels = ({ tags, className = '' }: Props) => {
  const {
    premiumType,
    onsenExists,
    hometownTax,
    sustainableHotelActivity,
    memberRankBenefits,
    hotelMembershipExchange,
  } = tags;
  return (
    <div className={cx(styles.labelsWrapper, className)}>
      {premiumType === GradeHotelType.HIGH_CLASS_HOTEL && <FeaturesHighClass />}
      {premiumType === GradeHotelType.TOP_CLASS_HOTEL && <FeaturesTopClass />}
      {onsenExists && <HotSpringLabel />}
      {sustainableHotelActivity && <SustainabilityLabel />}
      {hometownTax && <FurusatoTaxLabel />}
      {hotelMembershipExchange && (
        <HotelMembershipExchangeLabel hotelMembershipNameTxt={hotelMembershipExchange} />
      )}
      {memberRankBenefits === GradeMemberRank.DIAMOND_RANK_MEMBER && <FeaturesRankDiamond />}
      {memberRankBenefits === GradeMemberRank.PLATINUM_RANK_MEMBER && <FeaturesRankPlatinum />}
    </div>
  );
};

export default FeatureLabels;
